/**
 * Start the MSW browser worker when mocking is enabled.
 *
 * Enabled in dev by default, and in any build when `VITE_ENABLE_MSW=true` (used
 * by the Playwright preview build, since the LJP-02 backend does not exist yet).
 * When the real backend lands, run without the flag and the app talks to it.
 */
export async function enableMocking(): Promise<void> {
  const flag = import.meta.env.VITE_ENABLE_MSW;
  const shouldMock =
    flag === 'true' || (import.meta.env.DEV && flag !== 'false');
  if (!shouldMock) return;

  const { worker } = await import('./browser');
  await worker.start({
    onUnhandledRequest: 'bypass',
    serviceWorker: { url: `${import.meta.env.BASE_URL}mockServiceWorker.js` },
  });
}
